<template>
  <div class="pay-container">
    <van-nav-bar :title="$route.meta.title">
      <template #left>
        <van-icon @click="back" name="arrow-left" color="#46474B" size="20px" />
      </template>
    </van-nav-bar>
      <div class="pay-success text-align-center">
      <img src="@/assets/pay-state/pay-success.png" alt="">
      <p class="status">
        支付成功
      </p>
      <!-- 1v1 -->
      <p v-if="$route.query.buyServiceType === '1'" class="msg font14">
        <!-- 已成功购买<span>{{ $route.query.lawyerName }}</span>律师的服务，快去咨询您的问题吧 -->
        已成功购买<span>{{ $route.query.lawyerName }}</span>律师的服务，<span v-html="tipsText" class="html-content"></span>
      </p>
      <!-- 2.1.3新添加公共咨询付费类型 -->
        <p class="msg msg-sucess font14" v-else-if="$route.query.buyServiceType === '3'">
          <label v-if="timeIsNight">当前为非工作时间段（{{ `${_startTime}-${_endTime}` }}），值班律师<br>较少。您的问题平台已加急派送，如长时间无人接<br>单，工作时间律师将会优先为您解答</label>
          <!--        <label v-else>问题<i class="msg-common-i">加速</i>曝光中...更多律师将会为您提供解决方案</label>-->
          <label v-else>您的问题，我们已通知平台律师，律师会<br>在稍后几分钟为您解答</label>
          <!--        <label v-else>律师将尽快与您联系，<br>可前往<span @click="jump"> 我的咨询 </span>查看律师接单进度</label>-->
        </p>
      <!-- 赞赏 -->
      <p v-else-if="$route.query.buyServiceType === '4'" class="msg msg-sucess font14">
          律师已收到您的赞赏，谢谢您的认可~
      </p>
      <!-- 追问 -->
      <p v-else-if="$route.query.buyServiceType === '6'" class="msg msg-sucess font14">
          感谢您的认可，请继续深入追问
      </p>
        <!-- 悬赏 -->
        <p v-else-if="$route.query.buyServiceType === '7'" class="msg msg-sucess font14">
          您的问题，已进入平台快速咨询通道，律<br>师会在稍后几分钟为您解答。
        </p>
        <!-- 打赏 -->
        <p v-else-if="$route.query.buyServiceType === '8'" class="msg msg-sucess font14">
          律师已收到您的打赏，感谢您对律师和平台的支持
        </p>

        <p
            v-else-if="$route.query.buyServiceType === '9'"
            class="msg msg-sucess font14"
        >
          购买成功，您可以点击下载合同模板
        </p>
      <p v-else class="msg-none" />
      <div :class="['btns flex flex-column' ,($route.query.buyServiceType === '3') && 'zgh-btn' ] ">
         <!--2.1.3新添加公共咨询付费类型不展示  -->
        <!-- <button @click="jump" v-if="!hiddenBtnOne"> -->
        <button @click="jump">
          {{ showData.msg }}
        </button>
        <!-- <button @click="toOrder">
          我的订单查看
        </button> -->
      </div>
        <!--    公众号   -->
      <div v-if="$route.query.buyServiceType === '3'" class="gzh-box position-relative">
        <img class="gzh-banner" src="@/assets/pay-state/Group8293@2x.png" alt="">
        <img class="gzh-tag position-absolute" src="@/assets/pay-state/btn-tag.png" alt="">
        <button @click="handleGzh">前往公众号</button>
      </div>
    </div>
  </div>
</template>

<script>
/**
  buyServiceType 0-其他服务(历史服务), 1-1V1服务, 2-案源付费服务,3-1v1公共咨询服务
 */
import { getServerAndImInfo } from '@/api/falinapi'
import { callApp } from '@/libs/bridge'
import { BURY_POINT_TYPE, BEHAVIOR } from '@/libs/config'
// import { POINT_CODE, BURY_POINT_TYPE, BEHAVIOR,newOrderType } from '@/libs/config'
import { NavBar, Icon } from 'vant'
import nightTime from '@/mixins/nightTime.js'
import {buriedChannelPoint} from "@a/common.js";
export default {
  components: {
    'van-icon': Icon,
    'van-nav-bar': NavBar
  },
  data () {
    return {
      lawyerSessionData: {}// 获取会话id
    }
  },
  mixins: [nightTime],
  computed: {
    // 不展示第一个按钮
    hiddenBtnOne () {
      return  this.$route.query.buyServiceType === '4'
    },
    // IOS汇付宝使用
    showData () {
      const { buyServiceType, lawyerId, businessId, articleId } = this.$route.query
      let data = { msg: '开启咨询服务', path: '/' }
      switch (Number(buyServiceType)) {
        case 1:
          data = { msg: '我知道了', data: { lawyerId, businessId } }
          break
        case 2:
          data = { msg: '查看案件详情', data: { businessId } }
          break
        case 3:
          data = { msg: '我知道了', data: {} }
          break
        case 5:
          data = { msg: '查看问答', data: { articleId } }
          break
        case 4:
       case 6: // 追问
          data = { msg: '我知道了', data: {} }
          break
        case 7: // 悬赏
          data = { msg: '我知道了', data: {} }
          break
        case 8: // 打赏
          data = { msg: '我知道了', data: {} }
          break
        case 9:
          data = { msg: '立即下载', data: {} }
          break
        default:
          data = { msg: '开启咨询服务', data: { lawyerId, businessId } }
          // buryPointPageCode: POINT_CODE['1V1_DHZX_ZFCG_PAGE']
          break
      }
      return data
    },
     // 提示文案
    tipsText () {
      return this.timeIsNight
        ? '当前律师<br>可能正在休息，将在工作时间为您服务哦'
        : '快去咨询您的问题吧'
    },
  },
  async mounted () {
    // ['1', '6'].includes(this.$route.query.buyServiceType)  && await this.getSession()
    // 2.2.8版本无赞赏 4了 但为了保险加上4
    ['1', '4','6'].includes(this.$route.query.buyServiceType)  && await this.getSession()
    this.buryPointPage()
    callApp('paySuccess')
    window.physicsBackFn = this.back
  },
  methods: {
    buryPointPage () {
      const params = {
        code: 'LAW_PAGE_ORDER_PAY_SUCCESS',
        type: BURY_POINT_TYPE.PAGE,
        behavior: BEHAVIOR.VI,
        role: 1,
        extra: {
          serverCode: Number(this.$route.query.serviceCode) || null,
          newUser: true
        }
      }
      buriedChannelPoint(params)
    },
    async getSession () {
      const { lawyerId, businessId, createFrom } = this.$route.query
      try {
        const params = {
          lawyerId,
          caseSourceServerV2Id: businessId,
          createFrom
        }
        const res = await getServerAndImInfo(params)
        this.lawyerSessionData = res.data || {}
      } catch (error) {
        console.log(error)
      }
    },
    back () {
      callApp('finishActivity')
    },
    // 成功
    jump () {
      // 页面埋点
      // this.showData.buryPointPageCode && this.buryPointPage(this.showData.buryPointPageCode,BEHAVIOR.CK)
      // callApp('paySuccess')
      // callApp('finishActivity')
      // this.$router.push(this.showData.path)
      switch (Number(this.$route.query.buyServiceType)) {
        case 1:
          callApp('openConsultation', { sessionId: this.lawyerSessionData ? this.lawyerSessionData.imSessionId : 0 })
          break
        case 2:
          callApp('viewCaseDetail', { businessId: this.$route.query.businessId })
          break
        case 3://我的咨询
          callApp('toMyAdvisoryList')
          break
        case 5:
          callApp('viewQuestionDetail', { articleId: this.$route.query.articleId })
          break
        case 6:
          callApp('openConsultation', { sessionId: this.lawyerSessionData ? this.lawyerSessionData.imSessionId : 0 })
          break
        case 7:
          callApp('openRewardDetail', { businessId: this.$route.query.businessId })
          break
        case 8:
          callApp('finishActivity')
          break
        case 9:
          callApp('downloadTheFile', { congruenceId: this.$route.query.businessId })
          break
      }
      // this.$route.query.buyServiceType === '1' ? callApp('openConsultation', { sessionId: this.lawyerSessionData ? this.lawyerSessionData.imSessionId : 0 })
      //   : callApp('viewCaseDetail', { businessId: this.$route.query.businessId })
    },
    // 去我的订单
    toOrder () {
      callApp('toMineOrderLs')
    },
    // 去公众号 toWeChatOfficialAccount
    handleGzh () {
      callApp('toWeChatOfficialAccount')
    }
  }
}
</script>

<style scoped lang="scss">
.pay-container{
  min-height: 100vh;
  background: white;
}
.pay-success{
  font-size: 0;
    .status{
    padding: 29px 0 8px 0;
    font-size: 18px;
    color: #333333;
  }
  .msg{
    color: #666666;
    padding-bottom: 24px;
    font-size: 14px;
    letter-spacing: 0;
    span{
      color: #177EFF ;
    }
    .html-content{
      color: #666666;
    }
    &-none{
      width: 375px;
      height: 56px;
    }
  }
  .msg-sucess{
    line-height: 18px;
  }
  img{
    padding-top: 48px;
    width: 121px;
    height: 120px;
  }
  .btns{
    align-items: center;
    &.zgh-btn{
      button{
        width: 100px;
        border: 1px solid #EEEEEE;
        background-color: #FFFFFF;
        color: #3887F5;
        font-size: 13px;
      }
    }
    button{
      width: 160px;
      height: 32px;
      border-radius: 20px;
      border: 1px solid #366EFF;
      font-size: 14px;
      background: #366EFF;
      color: #fff;
    }
    button{
      &:nth-child(2){
        background: white;
        margin-top: 15px;
        border-radius: 20px;
        border: 1px solid #EEEEEE;
        color: #333333;
      }
    }
  }
}
.gzh-box {
  .gzh-banner {
    width: 212px;
    height: 140px;
    margin-bottom: 28px;
  }

  button {
    width: 271px;
    height: 40px;
    background: #3887F5;
    border-radius: 22px 22px 22px 22px;
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 500;
    border: 1px solid #3887F5;
  }

  .gzh-tag {
    width: 165px;
    height: 21px;
    bottom: 35px;
    left: 38%;
  }
}
</style>
